<template>
  <div style="width: 95%">
        <div class="text-right">
            <Button type="primary" size="mini" @click="saveGst">{{$t('PROFILE_SAVE')}}</Button>
        </div>
            <div class="mt-10 table-with-add">
                <div class="add-block" @click="addNew">{{$t('TRANSPORTER_PROFILE_ADD_GSTIN')}}</div>
                <div>
                    <Table
                        :data="gstDetails"
                        class="table-striped bordered mt-10"
                        aria-describedby="gstDetailsData"
                        >
                        <table-column
                        :label="$t('STATE')"
                        width="200">
                            <template slot-scope="scope">
                                <span>
                                    <Select v-model="scope.row.state" :placeholder="$t('TRANSPORTER_PROFILE_SELECT_STATE')"
                                        size="mini"
                                        class="select-default p-0 no-bg">
                                        <Option
                                            v-for="state in states"
                                            :key="state.code"
                                            :label="state.name"
                                            :value="state.name"
                                            :disabled="checkStatus(state.name)"
                                            >
                                        </Option>
                                    </Select>
                                </span>
                            </template>
                        </table-column>
                        <table-column
                        :label="$t('TRANSPORTER_PROFILE_GSTN')"
                        width="180">
                            <template slot-scope="scope">
                                <span>
                                <Input
                                    class="input-blank italic-font w-150 p-0"
                                    :placeholder="$t('TRANSPORTER_PROFILE_ENTER_GSTN')"
                                    size="mini"
                                    type="text"
                                    v-model="scope.row.number"/>
                                </span>
                            </template>
                        </table-column>
                        <table-column
                        :label="$t('REFERENCE_ID')"
                        width="140">
                            <template slot-scope="scope">
                                <span>
                                <Input
                                    class="input-blank italic-font w-150 p-0"
                                    :placeholder="$t('TRANSPORTER_PROFILE_ENTER_REFERENCE_ID')"
                                    size="mini"
                                    type="text"
                                    v-model="scope.row.ref_id"/>
                                </span>
                            </template>
                        </table-column>
                        <table-column
                        :label="$t('ACK_NO')"
                        width="130">
                            <template slot-scope="scope">
                                <span>
                                <Input
                                    class="input-blank italic-font w-150 p-0"
                                    :placeholder="$t('TRANSPORTER_PROFILE_ENTER_ACK_NO')"
                                    size="mini"
                                    type="text"
                                    v-model="scope.row.ack_no"/>
                                </span>
                            </template>
                        </table-column>
                        <table-column
                        :label="$t('ACK_DATE')"
                        width="150">
                            <template slot-scope="scope">
                                <span>
                                  <DatePicker
                                    v-model="scope.row.ack_date"
                                    :placeholder="$t('TRANSPORTER_PROFILE_ENTER_ACK_DATE')"
                                    type="date"
                                    class="date-plain no-bg"
                                    border="none"
                                  />
                                </span>
                            </template>
                        </table-column>
                        <table-column
                        :label="$t('MDM_GST_TYPE')"
                        width="120">
                            <template slot-scope="scope">
                                <span>
                                    <Select v-model="scope.row.gst_type"
                                        placeholder="Select *"
                                        size="mini"
                                        class="select-default p-0 no-bg">
                                        <Option
                                            v-for="type in gstTypes"
                                            :key="type.id"
                                            :label="type.name"
                                            :value="type.id"
                                            >
                                        </Option>
                                    </Select>
                                </span>
                            </template>
                        </table-column>
                        <table-column
                        :label="$t('MDM_GST_PERCENTAGE')"
                        width="140">
                            <template slot-scope="scope">
                                <span>
                                <Input
                                    class="input-blank italic-font p-0"
                                    placeholder="Enter *"
                                    size="mini"
                                    type="number"
                                    v-model="scope.row.gst_percentage"/>
                                </span>
                            </template>
                        </table-column>
                        <table-column
                          :label="$t('MDM_ADDRESS')"
                          width="150">
                          <template slot-scope="scope">
                            <span>
                            <Input
                              class="input-blank italic-font w-150 p-0"
                              :placeholder="$t('TRANSPORTER_PROFILE_ENTER_ADDRESS')"
                              size="mini"
                              type="text"
                              v-model="scope.row.address"/>
                            </span>
                          </template>
                        </table-column>
                        <table-column width="30">
                            <template slot-scope="scope">
                                <Tooltip :open-delay="100" effect="dark" placement="bottom">
                                <i class="action-row" @click="removeEntry(scope.$index, scope.row.id)">
                                    <svgicon name="icon-delete-md" width="14" height="14" :original="true"/>
                                </i>
                                <div slot="content">{{$t('TRANSPORTER_PROFILE_DELETE')}}</div>
                                </Tooltip>
                            </template>
                        </table-column>
                    </Table>
                </div>
                </div>
        </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import states from '@/constants/india-states';
import { gstTypes } from '@/constants/payments';

export default {
  name: 'Gst',
  computed: {
    ...mapGetters({
      currentTransporter: 'app/currentTransporter',
    }),
  },
  data() {
    return {
      states,
      gstTypes: gstTypes.slice(1),
      gstDetails: [],
      removedEntries: [],
    };
  },
  created() {
    if (this.currentTransporter.gst_number) {
      this.gstDetails = this.mapGstResponse(this.currentTransporter.gst_number);
    }
  },
  methods: {
    mapGstResponse(data) {
      return (data || []).map(gst => ({
        ...gst,
        gst_type: gst.gst_type || '',
        gst_percentage: gst.percentage != null ? gst.percentage : '',
      }));
    },
    checkStatus(state) {
      return this.currentTransporter.gst_number.some(trans => trans.state === state);
    },
    /**
     * Add a new gst row
     */
    addNew() {
      const id = Math.floor((Math.random() * 100) + 1);
      const defaultGst = {
        id,
        state: '',
        number: '',
        ref_id: '',
        ack_no: '',
        ack_date: '',
        address: '',
        gst_type: '',
        gst_percentage: '',
      };
      this.gstDetails.push(defaultGst);
    },
    /**
     * Handler to remove an existing row
     */
    removeEntry(index, targetId) {
      if (!Number.isInteger(targetId)) {
        this.removedEntries.push(targetId);
      }
      this.gstDetails.splice(index, true);
      this.gstDetails = cloneDeep(this.gstDetails);
    },
    /**
     * Handler to trigger delete api request
     */
    async deleteGst() {
      // Dispatch for delete
      const result = await this.$store.dispatch('app/deleteGst', { transporterId: this.currentTransporter.id, data: this.removedEntries });
      if (result.data && result.data.errors) {
        const message = (result.data.errors && result.data.errors[0].message) ? result.data.errors[0].message : 'Unable to Process';
        this.$error({ message });
        return false;
      }
      this.gstDetails = this.mapGstResponse(result.data || []);
      this.removedEntries = [];
      this.$success({ message: 'GSTIN updated' });
      return true;
    },
    /**
     * Handler to trigger update api request
     */
    async saveGst() {
      try {
        const hasDuplicate = this.checkGstDuplicate(this.gstDetails);
        if (hasDuplicate) {
          this.$error({ message: 'Duplicate GSTIN. Please check.' });
        } else if (this.gstDetails.some(gst => !gst.gst_type || gst.gst_percentage === '' || gst.gst_percentage === null)) {
          this.$error({ message: 'GST Type and GST Percentage are mandatory.' });
        } else {
          const data = this.gstDetails.map(gst => ({
            state: gst.state,
            number: gst.number,
            ref_id: gst.ref_id,
            ack_no: gst.ack_no,
            ack_date: gst.ack_date,
            address: gst.address,
            gst_type: gst.gst_type,
            gst_percentage: parseFloat(parseFloat(gst.gst_percentage).toFixed(2)),
          }));
          const result = await this.$store.dispatch('app/updateGst', { transporterId: this.currentTransporter.id, data });
          if (result.data && result.data.errors) {
            const message = (result.data.errors && result.data.errors[0].message) ? result.data.errors[0].message : 'Unable to Process';
            this.$error({ message });
            return false;
          }
          this.gstDetails = this.mapGstResponse(result.data);
          if (this.removedEntries.length) {
            await this.deleteGst();
          } else {
            this.$success({ message: 'GSTIN updated' });
          }
          return true;
        }
      } catch (error) {
        this.$error({ message: 'Unable to Process' });
      }
      return false;
    },
    /**
     * Helper handler to check for duplicates
     */
    checkGstDuplicate(data) {
      const gstNumber = data.map(item => item.number);
      const isDuplicate = gstNumber.some((item, idx) => gstNumber.indexOf(item) != idx);
      return isDuplicate;
    },
  },
};
</script>
